import { useEffect, useState } from "react";
import authAPI from "@/api/auth";
import { useAuth } from "@/contexts/AuthContext";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const environmentStyles = {
  staging:
    "border-orange-300 bg-orange-100 text-orange-800 dark:border-orange-800 dark:bg-orange-950/40 dark:text-orange-300",
  production:
    "border-green-300 bg-green-100 text-green-800 dark:border-green-800 dark:bg-green-950/40 dark:text-green-300",
};

export function SessionContext() {
  const { user } = useAuth();
  const [sessionContext, setSessionContext] = useState(null);

  useEffect(() => {
    let active = true;

    authAPI
      .getSessionContext({ config: { showGlobalLoading: false } })
      .then((response) => {
        if (active && response.success) {
          setSessionContext(response.data);
        }
      })
      .catch(() => {
        if (active) {
          setSessionContext(null);
        }
      });

    return () => {
      active = false;
    };
  }, []);

  const environment = sessionContext?.environment || "unknown";
  const maskedIpAddress = sessionContext?.maskedIpAddress;

  return (
    <div
      className="flex min-w-0 items-center gap-2 text-xs text-muted-foreground"
      aria-label="현재 접속 정보"
    >
      <Badge
        variant="outline"
        className={cn(
          "shrink-0 px-2 py-0.5",
          environmentStyles[environment] ||
            "border-slate-300 bg-slate-100 text-slate-700 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300"
        )}
      >
        {environment.toUpperCase()}
      </Badge>

      <span className="hidden max-w-32 truncate font-medium text-foreground sm:inline">
        {user?.userId || "-"}
      </span>

      {maskedIpAddress && (
        <>
          <span className="hidden text-border md:inline" aria-hidden="true">
            |
          </span>
          <span className="hidden whitespace-nowrap md:inline">
            {maskedIpAddress}
          </span>
        </>
      )}
    </div>
  );
}
